import SessionEventProto from "../session-event-proto"
import {MyWorkType} from "../../../app/home/my-work/common/model/@const"

// @ts-ignore
import MyWorkModel from '../../gd-model/my-work/my-work-model'

// const debug = "SessionEvent_MyWorkNew"
const debug = false

export default class SessionEvent_MyWorkNew extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        if (this.isDifferentCompany()) {
            return
        }

        if (!gd.session.myWork) return

        const newModel = new MyWorkModel(this.data, {parse: true})
        gd.session.myWork.add(newModel, {silent: false})
        gd.bus.triggerEvent('gd.session.myWork:add')

        debug && console.log(debug, "process", this.data)

        // temporary solution for new my work (for dateCreated, isNew and fromUserId)
        if (this.data.task) {
            gd.modelBus.newUpdate('my-work-task', 'new', this.data.task.id, _.assign({}, this.data.task, {
                properties: {
                    'myWork': {
                        'actionRequired': {
                            sinceMoment : this.data.dateCreated,
                            isNew       : this.data.isNew,
                            fromUserId  : this.data.fromUserId,
                        }
                    }
                }
            }), {
                task        : this.data.task,
                isBulkUpdate: true,
            })
        }

        // temporary solution for new my work event
        if (this.data.event) {
            gd.modelBus.newUpdate('event', 'new', this.data.event.id, _.assign({}, this.data.event), {
                event       : this.data.event,
                isBulkUpdate: true,
            })
        }

        if (this.data.type === MyWorkType.TODO) {
            gd.modelBus.newUpdate('my-work-todo', 'new', this.data.id, _.assign({}, this.data), {
                todo        : this.data,
                isBulkUpdate: true,
            })
        }
    }

}
